<icms-outlet [components]="content?.components"
             [allow]="allow"
             [allowOnly]="allowOnly"
             [disallow]="disallow"
             [main]="main"
             [name]="name" />